import { PulseLoading, ToggleButton } from '..'

type TProfileSection = {
  readonly label: string
  readonly value: string
  readonly isLoading: boolean
  readonly disableOnChange?: boolean
  readonly onChange: () => void
  readonly onToggleChange?: (state: boolean) => void
  readonly actionType?: 'button' | 'toggle'
  readonly toggleState?: boolean
  readonly actionLabel?: string | null
}

export default function ProfileSection({
  label,
  value,
  isLoading,
  disableOnChange,
  onChange,
  actionType = 'button',
  onToggleChange,
  toggleState = false,
  actionLabel = 'Change',
}: TProfileSection) {
  if (isLoading) {
    return <PulseLoading />
  }

  return (
    <div className='flex flex-col gap-4'>
      <h3 className='text-xs font-semibold'>{label}</h3>
      <div className='flex flex-row items-start justify-between gap-4'>
        <p className='sentry-mask break-all text-xs font-normal text-pop-grey-500'>{value}</p>
        {!disableOnChange && actionType === 'button' && (
          <button
            className={`cursor-pointer text-right text-xs font-normal text-pop-blue-400`}
            onClick={onChange}
            type='button'
          >
            {actionLabel}
          </button>
        )}
        {!disableOnChange && actionType === 'toggle' && onToggleChange && (
          <ToggleButton onToggleButton={onToggleChange} state={toggleState} />
        )}
      </div>
    </div>
  )
}
